export const TRANSITION_METHOD = {
  JUMP: 1,
  GROUND_NAV: 2,
};
